<alaris-icon
	[name]="campaign.setup.channels.length > 1 ? 'icon-Multi-plan-v2' : cu.icon(campaign.setup.channels[0].channelType)"
	class="icon"
></alaris-icon>

<div class="name">
	<div [alarisTooltip]="campaign.info.name ?? ''" [overflow]="true" class="title">{{ campaign.info.name }}</div>
	@let repeatRule = campaign.settings.repeatRule;
	@if (repeatRule && schedulerUtils.isCurrentlyRepeating(repeatRule)) {
		<alaris-icon
			[alarisComplexTooltip]="CampaignNextRepeatComponent"
			[componentData]="{ nextRunAt: repeatRule.nextRunAt, info: campaign.info }"
			name="icon-arrow-move-list"
			class="repeat-icon"
		></alaris-icon>
	}
</div>

<div class="content">
	@if (campaign.setup.native) {
		@let templateID = campaign.setup.channels[0].message?.templateID;
		@if (templateID) {
			<button (click)="navigateToTemplate(templateID)" class="file" data-testid="exportBtn">
				{{ 'templates.template' | translate }}:
				{{ (templateID | message)?.name }}
			</button>
		} @else {
			<div
				[maxWidth]="250"
				[alarisTooltip]="campaign.setup.channels[0].message?.text ?? ''"
				[overflow]="true"
				class="message"
			>
				{{ campaign.setup.channels[0].message?.text ?? '' }}
			</div>
		}
	}
	@if (campaign.setup.file) {
		@if (campaign.setup.file) {
			<button
				(click)="export(campaign.setup.file.file.id, campaign.setup.file.file.name)"
				class="file"
				data-testid="exportBtn"
			>
				{{ campaign.setup.file.file.name }}
			</button>
		}
	}
</div>

@if (campaign.recurrentHistory?.length) {
	<alaris-icon
		[alarisTooltip]="'campaigns.viewRepeats' | translate"
		aria-expanded="true"
		name="icon-caret-right"
		class="arrow-icon"
	></alaris-icon>
}
